"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "veglio": {
    "e8db817e": [{
      "hkey": "324370d4",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "borgo": [{
      "hkey": "324370d4",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "daa7b890": [{
      "hkey": "c27d70a8",
      "slug": "veglio",
      "name": "Veglio",
      "primary": true,
      "skipSearch": false
    }],
    "capeggia": [{
      "hkey": "c27d70a8",
      "slug": "veglio",
      "name": "Veglio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "005b498e": [{
      "hkey": "324370d4",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "dazza": [{
      "hkey": "324370d4",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "veglio"
    }],
    "901a4ce1": [{
      "hkey": "324370d4",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "prina": [{
      "hkey": "324370d4",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "veglio"
    }],
    "265164d0": [{
      "hkey": "c27d70a8",
      "slug": "veglio",
      "name": "Veglio",
      "primary": true,
      "skipSearch": false
    }],
    "seletto": [{
      "hkey": "c27d70a8",
      "slug": "veglio",
      "name": "Veglio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c956cf28": [{
      "hkey": "c27d70a8",
      "slug": "veglio",
      "name": "Veglio",
      "primary": true,
      "skipSearch": false
    }],
    "sella": [{
      "hkey": "c27d70a8",
      "slug": "veglio",
      "name": "Veglio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "65bebff0": [{
      "hkey": "c27d70a8",
      "slug": "veglio",
      "name": "Veglio",
      "primary": true,
      "skipSearch": false
    }],
    "steglia": [{
      "hkey": "c27d70a8",
      "slug": "veglio",
      "name": "Veglio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1c9770a3": [{
      "hkey": "c27d70a8",
      "slug": "veglio",
      "name": "Veglio",
      "primary": true,
      "skipSearch": false
    }],
    "valle": [{
      "hkey": "c27d70a8",
      "slug": "veglio",
      "name": "Veglio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8bf9f973": [{
      "hkey": "c27d70a8",
      "slug": "veglio",
      "name": "Veglio",
      "primary": true,
      "skipSearch": false
    }],
    "zerbola": [{
      "hkey": "c27d70a8",
      "slug": "veglio",
      "name": "Veglio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;